import type { FC } from 'react'

import { CardEmbedment, CardPrimaryLoading, CardVariant } from '@hcr/ui'

export const HoldingPreviewLoading: FC = () => {
  return <CardPrimaryLoading embedment={CardEmbedment.Carousel} variant={CardVariant.Regular} />
}
